// extracted by mini-css-extract-plugin
export default {"container":"mediaFooter_container__XWKi9","wrapper":"mediaFooter_wrapper__tjqIg","btn":"mediaFooter_btn__sXkfU"};